import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { theme } from "../../styles/theme";

export const GlobalLoaders = () => {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        // flexGrow={1}
        backgroundColor="red"
        position="absolute"
        width="100%"
        height="100%"
        zIndex={200}
        sx={{
          background: "rgba(255, 255, 255, 0.28)",
          backdropFilter: "blur(4.2px)",
        }}
      >
        <CircularProgress sx={{ color: theme.col_2 }} size="50px" />
      </Box>
    </>
  );
};
